import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const reviews = [
  {
    text: "I've had this company to do a few different things around my home. The quality of work and the personal connection was amazing. Explained things to me where I knew what was happening. All very polite and genuine.",
    name: 'Heather B.',
    role: 'Homeowner',
  },
  {
    text: "I can't say enough good things about this company. I previously had two contractors come in and needless to say they did not leave the job properly done. I called Brian at Downs Construction and they got right on it.",
    name: 'John S.',
    role: 'Homeowner',
  },
  {
    text: "Brian and his team did an outstanding job on our garage addition. Everything was done on time, within budget, and the quality exceeded our expectations. Highly recommend to anyone in Southwest Michigan.",
    name: 'Melissa T.',
    role: 'Homeowner',
  },
  {
    text: "Professional, reliable, and honest. Brian walked us through every step of our home renovation. The attention to detail was impressive. Will definitely use Downs Construction again for future projects.",
    name: 'David K.',
    role: 'Homeowner',
  },
];

export default function ReviewsSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="reviews" className="bg-[#fafaf8] py-20 lg:py-32">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 sm:px-8 lg:px-16 transition-all duration-700 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="flex items-center justify-center gap-3 mb-3">
            <div className="w-8 h-0.5 bg-primary"></div>
            <span className="text-primary text-xs font-bold uppercase tracking-[0.3em]">Our Reviews</span>
            <div className="w-8 h-0.5 bg-primary"></div>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase text-gray-900 mb-4" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            Words From Our Customers
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            We take pride in our dedicated customer service and exceptional craftsmanship. With a focus on quality materials, clear communication, and reliable results, every project exceeds expectations.
          </p>
        </div>

        {/* Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {reviews.map((r, i) => (
            <div
              key={r.name}
              className="bg-white rounded-lg p-7 flex flex-col gap-4 hover-card border border-gray-100"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(24px)',
                transition: `all 0.7s ease ${i * 100}ms`,
              }}
            >
              <img
                src="https://csimg.nyc3.digitaloceanspaces.com/Reviews/stars-yellow.svg"
                alt="5 stars"
                className="w-24 h-4"
                loading="lazy"
                decoding="async"
              />
              <p className="text-gray-700 text-sm leading-relaxed flex-1 italic">&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-3 border-t border-gray-100">
                <div className="w-10 h-10 flex items-center justify-center bg-primary rounded-full text-white font-bold text-sm flex-shrink-0">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <div className="text-gray-900 font-bold text-sm">{r.name}</div>
                  <div className="text-gray-500 text-xs">{r.role}</div>
                </div>
                <div className="ml-auto">
                  <i className="ri-double-quotes-r text-primary/20 text-3xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://www.google.com/search?q=Downs+Construction+LLC+Battle+Creek+MI"
            rel="nofollow"
            target="_blank"
            className="inline-flex items-center gap-2 border-2 border-primary text-primary hover:bg-primary hover:text-white text-xs font-bold uppercase tracking-widest px-8 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap btn-press"
          >
            Read More Reviews <i className="ri-external-link-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
